export default __webpack_public_path__ + "media/images/images_v2/onglet-droite3-0e000a466e49715d027f73a91a567ab2.png";